import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import BookSelect from 'components/BookSelect/BookSelect';
import * as searchUnitActions from 'actions/searchUnitActions';
import { getFlexDurationNights } from 'utils/utils';

/* istanbul ignore next */
const mapStateToProps = state => ({
  dimensionsEntities: state.dimensionsEntities,
  dimensionsResult: state.dimensionsResult,
  baseState: state.baseState,
});

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    searchUnitActionsBound: bindActionCreators(searchUnitActions, dispatch),
  };
}

export class SearchUnitFlightPlusHotelLayout extends Component {
  static propTypes = {
    dimensionsEntities: PropTypes.object.isRequired,
    baseState: PropTypes.object.isRequired,
    dimensionsResult: PropTypes.object.isRequired,
    searchUnitActionsBound: PropTypes.object,
  };

  static defaultProps = {

  };

  get durationOptions() {
    const { dimensionsEntities, dimensionsResult } = this.props;

    const availableNightIds = dimensionsResult.get('D_Nights');
    const availableNights = [];
    const availableFlexibleNights = [];

    if (availableNightIds) {
      availableNightIds.map((dimId) => {
        const obj = dimensionsEntities.get(`${dimId}`);

        availableNights.push({
          label: `${obj.get('label')} Nights`,
          value: dimId,
          disabled: !obj.get('available'),
        });

        const flexibleDurationLabel = getFlexDurationNights(dimId);

        /* istanbul ignore else */
        if (flexibleDurationLabel) {
          availableFlexibleNights.push({
            label: `${flexibleDurationLabel} Nights`,
            value: `${dimId}-flexNights`,
            disabled: !obj.get('available'),
          });
        }
      });
    }
    return availableNights.concat(availableFlexibleNights);
  }

  onDurationChange = (event) => {
    const { searchUnitActionsBound } = this.props;
    const dimId = event.currentTarget.value;

    const isFlexDim = dimId.indexOf('-flexNights') > -1;
    const addDimId = isFlexDim ? dimId.replace('-flexNights', '') : dimId;

    searchUnitActionsBound.setDuration(addDimId, isFlexDim);
  }

  render() {
    const { baseState } = this.props;
    const selectedNightsDimIds = baseState.get('D_Nights', Immutable.List());
    const isFlexDurationSelected = baseState.getIn(['queryState', 'props', 'nightFlex', 'set']);

    return (
      <div className="search-unit-duration-layout">
        <BookSelect
          onFieldChange={this.onDurationChange}
          label="Duration:"
          value={`${selectedNightsDimIds.first()}${isFlexDurationSelected ? '-flexNights' : ''}`}
          options={this.durationOptions}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchUnitFlightPlusHotelLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/SearchUnitDurationLayout/SearchUnitDurationLayout.jsx
 **/